// extracted by mini-css-extract-plugin
export default {"setMobileHeight":"style-module--setMobileHeight--oySJN","wrapperFooter":"style-module--wrapperFooter--ny7mU"};